module.exports = __webpack_public_path__ + "static/media/b.e4badcd4.png";